export default __webpack_public_path__ + "static/media/feature_2.2b466162.png";